import { render, staticRenderFns } from "./PuzzleNumberSquareList.vue?vue&type=template&id=0c95ee33"
import script from "./PuzzleNumberSquareList.vue?vue&type=script&lang=js"
export * from "./PuzzleNumberSquareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports